import React from "react";
import { type IIconInterface } from "../icon.interface";
import { SvgIcon } from "../SvgIcon";

export const BriefcaseIcon: React.FC<IIconInterface> = (props): JSX.Element => {
  return (
    <SvgIcon title="Briefcase" viewBox="0 0 20 20" {...props}>
      <path
        d="M16.875 5.625H3.125C2.77982 5.625 2.5 5.90482 2.5 6.25V16.25C2.5 16.5952 2.77982 16.875 3.125 16.875H16.875C17.2202 16.875 17.5 16.5952 17.5 16.25V6.25C17.5 5.90482 17.2202 5.625 16.875 5.625Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 5.625V4.375C13.125 4.04348 12.9933 3.72554 12.7589 3.49112C12.5245 3.2567 12.2065 3.125 11.875 3.125H8.125C7.79348 3.125 7.47554 3.2567 7.24112 3.49112C7.0067 3.72554 6.875 4.04348 6.875 4.375V5.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2.5 12.5H17.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};
